import React, { useEffect, useRef, useState } from 'react'
import Api from '../../../../_helpers/Api'
import { Link } from 'react-router-dom'
import Skeleton from 'react-loading-skeleton'
import Filter from '../list/Filter'
import AddOrEdit from '../list/AddOrEdit'
import Options from '../list/ListOptions'
import SendMessage from '../list/SendMessage'
import Question from '../../../modals/messages/Question'
import Pagination from '../../../Pagination'
import { trans } from '../../../../_providers/Translation'
import closeIcon from '../../../../assets/img/icons/close.png'
import checkIcon from '../../../../assets/img/icons/check.png'

let timeout

function AllContractors(props) {

    const modalAddOrEditRef = useRef(null)
    const modalQuestionRef = useRef(null)
    const modalSendMessageRef = useRef(null)

    const [data, setData] = useState({
        loading: true,
        data: [],
        types: [],
        total: 0,
        pages: 0,
        page: 1,
        filter: {
            name: '',
            type_id: ''
        },
        update: new Date().getTime(),
    })

    useEffect(() => {
        if (data.update) {
            loadContractors()
        }
    }, [data.update])

    useEffect(() => {
        loadTypes()
    }, [])

    // read
    const loadContractors = () => {

        setData(prev => ({
            ...prev,
            loading: true
        }))

        let url = 'contractors/list?page=' + data.page

        Object.entries(data.filter).map(filter => {
            url += '&' + filter[0] + '=' + filter[1]
        })

        Api.get(url)
            .then(res => {
                setData(prev => ({
                    ...prev,
                    loading: false,
                    data: res.data.items,
                    pages: res.data.pages,
                    total: res.data.total
                }))
            }).catch(err => {
                setData(prev => ({
                    ...prev,
                    loading: false
                }))
            })
    }

    const loadTypes = () => {
        Api.get('contractors/types')
            .then(res => {
                setData(prev => ({
                    ...prev,
                    types: res.data
                }))
            })
    }

    //Search
    const handleSearch = (key, val) => {
        clearTimeout(timeout)

        setData(prev => ({
            ...prev,
            filter: {
                ...prev.filter,
                [key]: val,
            },
        }))

        timeout = setTimeout(() => {
            setData(prev => ({
                ...prev,
                page: 1,
                update: new Date().getTime()
            }))
        }, 300)
    }

    // create
    const handleAdd = () => {
        modalAddOrEditRef.current.add()
    }

    const handleCreate = () => {
        setData(prev => ({
            ...prev,
            update: new Date().getTime()
        }))
    }

    // update
    const handleEdit = id => {
        modalAddOrEditRef.current.edit(id)
    }

    const handleUpdate = row => {

        let updated = data.data.map(i => {
            if (i.id == row.id) {
                i = row
            }
            return i
        })

        setData(prev => ({
            ...prev,
            data: updated,
        }))
    }

    // delete
    const handleDestroy = id => {

        Api.post('contractors/delete', {
            id: id
        }).then(res => {
            if (res.data.success) {
                let filtered = data.data.filter(i => {
                    return i.id !== id
                })

                setData(prev => ({
                    ...prev,
                    data: filtered
                }))

                modalQuestionRef.current.close()
            }
        })
    }

    // Question modal
    const handleDelete = id => {
        modalQuestionRef.current.open(id)

        modalQuestionRef.current.onSuccess(() => {
            handleDestroy(id)
        })
    }

    const handlePage = page => {
        setData(prev => ({
            ...prev,
            page: page.selected + 1,
            update: new Date().getTime()
        }))
    }

    const handleSendMessage = id => {
        modalSendMessageRef.current.open(id)
    }

    return (
        <>
            <AddOrEdit
                ref={modalAddOrEditRef}
                handleCreate={handleCreate}
                handleUpdate={handleUpdate}
            />

            <Question
                ref={modalQuestionRef}
                mainMessage={trans('headings.confirmDelete')}
                secondaryMessage={trans('subheadings.confirmDelete')}
            />

            <SendMessage
                ref={modalSendMessageRef}
            />

            <div
                className="row"
                style={{
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <h3>
                    {trans('random.allCompanies')}
                </h3>
                <button className="button-add button-small" onClick={handleAdd}>
                    {trans('buttons.new')}
                </button>
            </div>

            <Filter
                filter={data.filter}
                types={data.types}
                handleSearch={handleSearch}
            />

            <hr />

            {data.loading
                ?
                <Skeleton height={45} count={10} />
                :
                data.data.length === 0
                    ?
                    <div className="alert warning">{trans('messages.noResultsFound')}</div>
                    :
                    <>
                        <div className="table-scroller">
                            <table>
                                <thead>
                                    <tr>
                                        <th style={{ width: '5%' }}>
                                            ID
                                        </th>
                                        <th style={{ width: '10%' }}>
                                            {trans('tables.company_name')}
                                        </th>
                                        <th style={{ width: '10%' }}>
                                            {trans('labels.email')}
                                        </th>
                                        <th className="center" style={{ width: '150px' }}>
                                            {trans('labels.sendReport')}
                                        </th>
                                        <th className="center" style={{ width: '150px' }}>
                                            {trans('labels.taxReservation')}
                                        </th>
                                        <th className="center" style={{ width: '150px' }}>
                                            {trans('labels.repairWarranty')}
                                        </th>
                                        <th className="center" style={{ width: '150px' }}>
                                            {trans('labels.active')}
                                        </th>
                                        <th className="options">
                                            {trans('tables.options')}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.data.map(c =>
                                        <tr key={'ac-' + c.id}>
                                            <td>
                                                {c.id}
                                            </td>
                                            <td style={{ width: '10%' }}>
                                                <Link to={'/contractors/preview/' + c.id}>
                                                    {c.name}
                                                </Link>
                                            </td>
                                            <td style={{ width: '10%' }}>
                                                {c.email || '-'}
                                            </td>
                                            <td className="center" style={{ width: '150px' }}>
                                                {c.send_reports
                                                    ?
                                                    <img src={checkIcon} height="12" />
                                                    :
                                                    <img src={closeIcon} height="12" />
                                                }
                                            </td>
                                            <td className="center" style={{ width: '150px' }}>
                                                {c.charge
                                                    ?
                                                    <img src={checkIcon} height="12" />
                                                    :
                                                    <img src={closeIcon} height="12" />
                                                }
                                            </td>
                                            <td className="center" style={{ width: '150px' }}>
                                                {c.repair_warranty
                                                    ?
                                                    <img src={checkIcon} height="12" />
                                                    :
                                                    <img src={closeIcon} height="12" />
                                                }
                                            </td>
                                            <td className="center" style={{ width: '150px' }}>
                                                {c.active
                                                    ?
                                                    <img src={checkIcon} height="12" />
                                                    :
                                                    <img src={closeIcon} height="12" />
                                                }
                                            </td>
                                            <td className="options">
                                                <Options
                                                    id={c.id}
                                                    handleEdit={handleEdit}
                                                    handleDelete={handleDelete}
                                                    handleSendMessage={handleSendMessage}
                                                />
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <Pagination
                            pages={data.pages}
                            page={data.page}
                            handlePage={handlePage}
                        />
                    </>
            }
        </>
    )
}

export default AllContractors
